// @import dependencies
import { CombinedReducers as IState } from 'app_events/index'
import React, { Component } from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import { ModalGenerateCertificationsModuleLayout } from 'app_components/modules/modalGenerateCertifications'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
// @end

// @import types
import { ICourseSchedulingEnrollmentListItem, ICourseSchedulingEnrollmentsHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @ADD Component types
interface IModalGenerateCertificationsModuleProps {
  open: boolean
  handleClose: (data: any) => void
  moodle_id: string
  course_scheduling: ICourseSchedulingListItem
}
interface IModalGenerateCertificationsModuleState {
  loading: boolean
  processing: boolean
  errors: Array<any>
  isAuditorCerficateEnabled: boolean
  firstCertificateIsAuditor: boolean
  previewCertificateParams: any
  schedulingMode: string
  students: ICourseSchedulingEnrollmentListItem[]
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => { return state }

class ModalGenerateCertificationsModule extends Component<IModalGenerateCertificationsModuleProps, IModalGenerateCertificationsModuleState> {

  private courseSchedulingEnrollmentService: CourseSchedulingEnrollmentService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalGenerateCertificationsModuleProps) {
    super(props)
    this.state = {
      loading: true,
      processing: false,
      errors: [],
      isAuditorCerficateEnabled: false,
      firstCertificateIsAuditor: false,
      previewCertificateParams: null,
      schedulingMode: '',
      students: [],
    }

    this.courseSchedulingEnrollmentService = new CourseSchedulingEnrollmentService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchStudentsWithoutCertificate()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => { }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => { }

  // @Add custom methods

  fetchStudentsWithoutCertificate = async () => {
    this.setState({ loading: true })

    console.log('Listado de estudiantes para generar certificado:')

    const httpParams: any = {
      isActive: false,
      courseID: this.props.moodle_id,
      course_scheduling: this.props.course_scheduling._id,
      without_certification: true,
    }

    let itemList: ICourseSchedulingEnrollmentsHttpResponse | null = await this.courseSchedulingEnrollmentService.certificateQueue(httpParams)

    console.log(itemList)
    if (itemList?.status_code === 'success') {
      this.setState({
        isAuditorCerficateEnabled: itemList?.isAuditorCerficateEnabled,
        firstCertificateIsAuditor: itemList?.firstCertificateIsAuditor,
        previewCertificateParams: itemList?.previewCertificateParams,
        schedulingMode: itemList?.schedulingMode,
        students: itemList?.enrollment,
        loading: false,
      })
    } else {
      this.setState({ loading: false })
    }
  }

  onHandleSubmit = async (data: any) => {
    this.setState({ processing: true, errors: [] })
    if (!data) {
      this.setState({ processing: false, errors: ['La información no es valida'] })
      return
    }

    if (!data.students || (data.students && data.students.length === 0)) {
      this.setState({ processing: false, errors: ['Debes seleccionar al menos un estudiante para generar certificados'] })
      return
    }

    console.log('Students selected:')
    console.log(data.students)

    const generateCertificationsResponse = await this.courseSchedulingEnrollmentService.generateCertifications({
      users: (Array.isArray(data.students)) ? data.students : [data.students],
      courseId: this.props.course_scheduling._id,
      status: 'New',
    })

    this.setState({ processing: false })
    if (generateCertificationsResponse) {
      this.props.handleClose({ status: 'success' })
    }
  }

  render() {
    return (
      <ModalGenerateCertificationsModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        onHandleSubmit={this.onHandleSubmit}
        loading={this.state.loading}
        processing={this.state.processing}
        errors={this.state.errors}
        isAuditorCerficateEnabled = {this.state.isAuditorCerficateEnabled}
        firstCertificateIsAuditor = {this.state.firstCertificateIsAuditor}
        previewCertificateParams = {this.state.previewCertificateParams}
        schedulingMode = {this.state.schedulingMode}
        students={this.state.students}
        courseScheduling={this.props.course_scheduling}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalGenerateCertificationsModule)
